import errors, { defaultError } from './constants'
import cookie from '../cookie'

export const getError = (code: string): AppError =>
  errors.find(e => e.code === code) || defaultError

const resetPasswordLinkUsedRegex = /url can be used only once/i
const resetPasswordLinkExpiredRegex = /access expired/i

const passwordlessLinkUsedRegex = /wrong email or verification code|maximum number of attempts/i
const passwordlessLinkExpiredRegex = /code has expired/i

const getCallbackErrorCode = (search: string): string => {
  const params = new URLSearchParams(search)
  const errorDescription = params.get('error_description') || ''
  if (resetPasswordLinkUsedRegex.test(errorDescription)) return 'reset_password.link_used.error'
  if (resetPasswordLinkExpiredRegex.test(errorDescription))
    return 'reset_password.link_expired.error'
  if (passwordlessLinkUsedRegex.test(errorDescription)) return 'passwordless.link_used.error'
  if (passwordlessLinkExpiredRegex.test(errorDescription)) return 'passwordless.link_expired.error'
  return 'callback.error'
}

export const getSignInUrl = (): string =>
  cookie.getCookie('ens_an_journeyType') === 'checkout' ? `/checkout` : `/sign-in?continueTo=/`

export const getInitialScreen = (code: string): string =>
  code.startsWith('passwordless') ? 'request_passwordless' : 'request_reset_password'

export const getCallbackError = (search: string): AppError => {
  const code = getCallbackErrorCode(search)
  return getError(code)
}
